export const routes = [
  {
    label: 'Propiedades',
    labelDisable: false,
    key: 'Properties',
    children: [
      {
        name: 'Propiedades',
        active: true,
        key: 'Properties',
        icon: 'home',
        children: [
          {
            name: 'Mis Propiedades',
            key: 'Properties',
            to: '/propiedades',
            active: true,
            exact: true
          },
          {
            name: 'Nueva Propiedad',
            key: 'Create properties',
            to: '/propiedades/cargar',
            active: true,
            exact: true
          }
        ]
      },
      {
        name: 'Emprendimientos',
        active: true,
        key: 'Properties',
        icon: 'building',
        children: [
          {
            name: 'Mis Emprendimientos',
            key: 'Properties',
            to: '/emprendimientos',
            exact: true,
            active: true
          },
          {
            name: 'Nuevo Emprendimiento',
            key: 'Create properties',
            to: '/emprendimientos/cargar',
            exact: true,
            active: true
          }
        ]
      },
      {
        name: 'Notificaciones',
        active: true,
        icon: 'bell',
        key: 'Notifications',
        children: [
          {
            name: 'Alertas',
            to: '/alertas',
            key: 'Alerts',
            exact: true,
            active: true
          },
          {
            name: 'Mensajes',
            key: 'Messages',
            to: '/mensajes',
            active: true,
            exact: true
          },
          {
            name: 'Notificaciones',
            key: 'Notifications',
            to: '/notificaciones',
            exact: true,
            active: true
          }
        ]
      },
      {
        name: 'Información',
        active: true,
        icon: 'chart-pie',
        key: 'Statistics',
        children: [
          {
            name: 'Resumen',
            to: '/resumen',
            key: 'Statistics',
            exact: true,
            active: true
          },
          {
            name: 'Estadísticas',
            to: '/estadisticas',
            key: 'Statistics',
            exact: true,
            active: true
          }
        ]
      },
      {
        name: 'Configuración',
        active: true,
        icon: 'cog',
        key: 'public',
        children: [
          {
            name: 'Mi Inmobiliaria',
            to: '/inmobiliaria',
            exact: true,
            active: true
          },
          {
            name: 'Mis Usuarios',
            to: '/usuarios',
            key: 'Users',
            exact: true,
            active: true
          },
          {
            name: 'Mis Permisos',
            to: '/permisos/roles',
            key: 'Roles',
            exact: true,
            active: true
          },
          {
            name: 'Mi Perfil',
            key: 'public',
            to: '/perfil',
            active: true,
            exact: true
          },
          {
            name: 'Integración',
            key: 'Integrations',
            to: '/integracion',
            active: true,
            exact: true
          },
          {
            name: 'Mercado Libre',
            key: 'Mercado Libre',
            to: '/ml',
            active: true,
            exact: true
          }
        ]
      },
      {
        name: 'Administrador',
        active: true,
        icon: 'cog',
        key: 'cucicba',
        children: [
          {
            name: 'Matriculados',
            to: '/usuarios/matriculados',
            key: 'matriculados',
            exact: true,
            active: true
          },
          {
            name: 'Inm. Integradas',
            to: '/admin/inmobiliarias-integradas',
            key: 'matriculados',
            exact: true,
            active: true
          }
        ]
      }
    ]
  },

  {
    label: 'Extras',
    labelDisable: false,
    children: [
      {
        name: 'Compartidos/as',
        active: true,
        icon: 'share',
        key: 'Shared',
        children: [
          {
            name: 'Propiedades',
            key: 'Shared',
            to: '/propiedades/compartidas',
            exact: true,
            active: true
          },
          {
            name: 'Emprendimientos',
            key: 'Shared',
            to: '/emprendimientos/compartidos',
            exact: true,
            active: true
          }
        ]
      },
      {
        name: 'Ayuda',
        active: true,
        icon: 'info-circle',
        key: 'public',
        children: [
          {
            name: 'Tutoriales',
            to: '/ayuda/tutoriales',
            exact: true,
            key: 'public',
            active: true
          },
          {
            name: 'Faqs',
            to: '/ayuda/faqs',
            exact: true,
            key: 'public',
            active: false
          }
        ]
      }
    ]
  }
  /* {
    label: 'Webmaster',
    labelDisable: false,
    children: [
      {
        name: 'Development',
        active: true,
        icon: 'code',
        children: [
          {
            name: 'Pruebas',
            to: '/dev/pruebas',
            exact: true,
            active: true
          }
        ]
      }
    ]
  } */
];
